import { format } from 'date-fns';

export interface ReportTemplate {
  id: string;
  name: string;
  description: string;
  sections: ReportSection[];
}

export interface ReportSection {
  title: string;
  type: 'text' | 'table' | 'chart' | 'metrics';
  content?: any;
}

export const reportTemplates: ReportTemplate[] = [
  {
    id: 'location-analysis',
    name: 'Location Analysis Report',
    description: 'Comprehensive analysis of a business location including demographics, market potential, and competition.',
    sections: [
      {
        title: 'Executive Summary',
        type: 'text'
      },
      {
        title: 'Demographics Analysis',
        type: 'chart'
      },
      {
        title: 'Market Metrics',
        type: 'metrics'
      },
      {
        title: 'Competition Analysis',
        type: 'table'
      }
    ]
  },
  {
    id: 'financial-projection',
    name: 'Financial Projection Report',
    description: 'Detailed financial projections including ROI analysis, cost estimates, and revenue forecasts.',
    sections: [
      {
        title: 'Financial Overview',
        type: 'text'
      },
      {
        title: 'Revenue Projections',
        type: 'chart'
      },
      {
        title: 'Cost Analysis',
        type: 'table'
      },
      {
        title: 'ROI Calculations',
        type: 'metrics'
      }
    ]
  },
  {
    id: 'property-comparison',
    name: 'Property Comparison Report',
    description: 'Side-by-side comparison of multiple properties with detailed metrics and analysis.',
    sections: [
      {
        title: 'Comparison Summary',
        type: 'text'
      },
      {
        title: 'Property Details',
        type: 'table'
      },
      {
        title: 'Performance Metrics',
        type: 'chart'
      },
      {
        title: 'Recommendations',
        type: 'text'
      }
    ]
  }
];

export function generateReportFileName(templateId: string): string {
  const template = reportTemplates.find(t => t.id === templateId);
  if (!template) return 'report';
  
  return `${template.name.toLowerCase().replace(/\s+/g, '-')}-${format(new Date(), 'yyyy-MM-dd')}`;
}